import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import styles from './EditDesignButton.module.scss';

interface Props {
  onEditHandler: () => void;
}

const EditDesignButton: FC<Props> = ({ onEditHandler }) => {
  const { t } = useTranslation();

  return (
    <button className={styles.whiteOutlinedBtn} onClick={() => onEditHandler()}>
      <OpText variant="body-large-medium">{t('txt_edit_design')}</OpText>
    </button>
  );
};

export default EditDesignButton;
